












































































import { computed, defineComponent, reactive } from '@vue/composition-api';
import VueSmartSwitch from '../ui/switch/VueSmartSwitch.vue';
import BaseAppModal from '../modal/BaseAppModal.vue';
import { useI18N } from '../../composables/use-vue-i18n';

export default defineComponent({
  name: 'RegionSwitcherModal',
  components: { BaseAppModal, VueSmartSwitch },
  setup: () => {
    const i18n = useI18N();

    const benefits = computed(() => {
      let index = 0;
      const ret = [];

      while (i18n.i18next.exists(`modal:region_switcher.modal.benefits.${index}`)) {
        ret.push(i18n.i18next.t(`modal:region_switcher.modal.benefits.${index}`));
        index++;
      }

      return ret;
    });

    const state = reactive({
      hideForever: false as boolean,
      benefits,
    });

    return {
      i18n,
      state,
    };
  },
});
